import React, { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
    const [scrollProgress, setScrollProgress] = useState(0);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const updateProgress = () => {
            const currentScroll = window.scrollY;
            const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
            if (scrollHeight > 0) {
                setScrollProgress((currentScroll / scrollHeight) * 100);
            }
            setIsVisible(currentScroll > 300);
        };

        window.addEventListener('scroll', updateProgress);
        return () => window.removeEventListener('scroll', updateProgress);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    if (!isVisible) return null;

    return (
        <div onClick={scrollToTop} className="stt-cyber-container">
            <style>{`
                .stt-cyber-container {
                    position: fixed;
                    bottom: 40px;
                    right: 40px;
                    width: 60px;
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    z-index: 1000;
                    transition: all 0.3s ease;
                }

                .progress-ring {
                    position: absolute;
                    transform: rotate(-90deg);
                }

                .progress-ring__circle {
                    stroke: #00d2ff;
                    stroke-dasharray: 157; /* 2 * PI * R (R=25) */
                    stroke-dashoffset: ${157 - (scrollProgress / 100) * 157};
                    transition: stroke-dashoffset 0.1s;
                    stroke-linecap: round;
                }

                .stt-icon-box {
                    width: 45px;
                    height: 45px;
                    background: #111;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: inset 0 0 10px rgba(0, 210, 255, 0.2);
                    border: 1px solid #222;
                    transition: 0.3s;
                }

                .stt-cyber-container:hover .stt-icon-box {
                    background: #00d2ff;
                    transform: scale(0.9);
                }

                .stt-arrow {
                    border: solid #00d2ff;
                    border-width: 0 3px 3px 0;
                    display: inline-block;
                    padding: 4px;
                    transform: rotate(-135deg);
                    transition: 0.3s;
                }

                .stt-cyber-container:hover .stt-arrow {
                    border-color: #000;
                }
            `}</style>

            <svg className="progress-ring" width="60" height="60">
                <circle
                    className="progress-ring__background"
                    stroke="rgba(255, 255, 255, 0.1)"
                    strokeWidth="4"
                    fill="transparent"
                    r="25"
                    cx="30"
                    cy="30"
                />
                <circle
                    className="progress-ring__circle"
                    strokeWidth="4"
                    fill="transparent"
                    r="25"
                    cx="30"
                    cy="30"
                />
            </svg>
            
            <div className="stt-icon-box">
                <span className="stt-arrow"></span>
            </div>
        </div>
    );
};

export default ScrollToTopButton;